import styled from 'styled-components';

interface UploadContainerProps {
  isUnfallreparatur?: boolean;
  isDisabled?: boolean;
}

export const StyledUploadContainer = styled.div<UploadContainerProps>`
  margin: 0;
  cursor: ${({ isDisabled }) => (isDisabled ? 'default' : 'pointer')};
  height: 140px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease-in-out;
`;

export const StyledText = styled.span<UploadContainerProps>`
  display: flex;
  align-items: center;
  position: relative;
  cursor: default;
  font-size: 12px;
  letter-spacing: 0.02em;
  padding-bottom: 5px;
  color: ${({ theme, isDisabled }) => (isDisabled ? theme.colors.grey200 : theme.colors.grey500)};
`;

export const StyledLink = styled.span<UploadContainerProps>`
  font-size: 12px;
  letter-spacing: 0.02em;
  text-decoration-line: underline;
  cursor: ${({ isDisabled }) => (isDisabled ? 'default' : 'pointer')};
  color: ${({ theme, isDisabled, isUnfallreparatur }) => {
    if (isDisabled) {
      return theme.colors.grey200;
    }

    if (isUnfallreparatur) {
      return theme.colors.blue;
    }

    return theme.colors.blue;
  }}; ;
`;
